export default function(val, el) {
  if (val) {
    el.classList.add("prevent-scroll")
  } else {
    el.classList.remove("prevent-scroll")
  }
}
